import React from 'react';
import { format } from 'date-fns';

export default function ReportPrintHeader({ title, startDate, endDate, region }) {
  return (
    <div className="hidden print:flex items-center justify-between mb-6 pb-4 border-b print:mb-4 print:pb-2">
      <div className="flex items-center gap-4">
        <img 
          src="/logo.png" 
          alt="Abbey 5 Star Ltd" 
          className="h-12 w-auto print:h-10"
        />
        <div>
          <h1 className="text-xl font-bold text-slate-800 print:text-lg">{title}</h1>
          <p className="text-sm text-slate-500">
            {format(new Date(startDate), 'dd MMM yyyy')} - {format(new Date(endDate), 'dd MMM yyyy')}
            {region && <span className="ml-2 px-2 py-0.5 bg-slate-100 rounded text-xs">{region}</span>}
          </p>
        </div>
      </div>
      <div className="text-right text-xs text-slate-400 print:text-[10px]">
        <p>Generated: {format(new Date(), 'dd MMM yyyy HH:mm')}</p>
        <p>Abbey 5 Star Ltd</p>
      </div>
    </div>
  );
}
